import React from 'react';
import Illustration from '@domain-group/fe-co-brand-illustrations';
import { ArrowRightIcon } from '@domain-group/fe-co-icon';
import { buildAppraisalUrl } from '../../../../utils';
import * as styles from './appraisal-cta-card.style';

export const APPRAISAL_ENTRY_POINT = 'Agency search results';
export const AGENT_APPRAISAL_ENTRY_POINT = 'Agent search results';

export interface AppraisalCtaCardProps {
  baseUrl?: string;
  isAgency?: boolean;
  onSelect?: () => void;
}

const AppraisalCtaCard = ({
  baseUrl,
  isAgency = false,
  onSelect,
}: AppraisalCtaCardProps): JSX.Element => {
  const href = buildAppraisalUrl({
    baseUrl,
    exitUrl: `${baseUrl ?? 'https://www.domain.com.au'}/${
      isAgency ? 'real-estate-agencies' : 'real-estate-agents'
    }`,
    entryPoint: isAgency ? APPRAISAL_ENTRY_POINT : AGENT_APPRAISAL_ENTRY_POINT,
  });

  return (
    <a
      css={styles.card}
      href={href}
      onClick={onSelect}
      onAuxClick={onSelect}
      data-testid="search-results-2026__appraisal-cta"
    >
      <Illustration type="spot" shape="circle" name="equityHome" size="large" />
      <div css={styles.content}>
        <h2 css={styles.title}>Skip the scrolling</h2>
        <p css={styles.description}>
          Tell us about your property and we&apos;ll recommend you local agents
          for a free market appraisal.
        </p>
        <span css={styles.cta}>
          Connect with an agent
          <ArrowRightIcon aria-hidden="true" />
        </span>
      </div>
    </a>
  );
};

export default AppraisalCtaCard;
